import { SkeletonText, Td } from '@chakra-ui/react';
import React from 'react';
import TableRow from 'components/TableRow';
import { FileDetailsReponse } from 'redux/services/dataLoader/types';
import { formatMoney, numberWithCommas } from 'utils';

interface PayrollMetricsRowsProps {
    dataFilePayrollLocal?: FileDetailsReponse;
    isLoading: boolean;
}

const PayrollMetricsRows: React.FC<PayrollMetricsRowsProps> = ({
    dataFilePayrollLocal,
    isLoading,
}) => {
    const requestData = dataFilePayrollLocal?.data;
    const totalAmount =
        dataFilePayrollLocal?.data?.metaData?.find(
            ({ key }) => key === "totalAmount"
        )?.value || 0;

    if (isLoading) {
        return (
            <>
                <TableRow>
                    <Td>Status</Td>
                    <Td>
                        <SkeletonText noOfLines={1} width="70px" />
                    </Td>
                </TableRow>
                <TableRow>
                    <Td>Total Amount</Td>
                    <Td>
                        <SkeletonText noOfLines={1} width="70px" />
                    </Td>
                </TableRow>
                <TableRow>
                    <Td>Total Employees</Td>
                    <Td>
                        <SkeletonText noOfLines={1} width="70px" />
                    </Td>
                </TableRow>
                <TableRow>
                    <Td>Total Failed</Td>
                    <Td>
                        <SkeletonText noOfLines={1} width="70px" />
                    </Td>
                </TableRow>
                <TableRow>
                    <Td>Total Succeed</Td>
                    <Td>
                        <SkeletonText noOfLines={1} width="70px" />
                    </Td>
                </TableRow>
            </>
        );
    }

    return (
        <>
            <TableRow>
                <Td>Status</Td>
                <Td>{requestData?.status}</Td>
            </TableRow>
            <TableRow>
                <Td>Total Amount</Td>
                <Td>
                    {totalAmount ? formatMoney(parseFloat(totalAmount)) : 0}
                </Td>
            </TableRow>
            <TableRow>
                <Td>Total Employees</Td>
                <Td>{numberWithCommas(requestData?.totalRecord)}</Td>
            </TableRow>
            <TableRow>
                <Td>Total Failed</Td>
                <Td>{numberWithCommas(requestData?.totalFailRecord)}</Td>
            </TableRow>
            <TableRow>
                <Td>Total Succeed</Td>
                <Td>{numberWithCommas(requestData?.totalSuccessRecord)}</Td>
            </TableRow>
        </>
    );
};

export default PayrollMetricsRows;
